import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { Lock } from "@common/types/lock";
import { getLock, getLocks } from "@lib/lock";
import { getLockDate } from "@helpers/lock";
import { getLockQueryKey, getLocksQueryKey } from "../queryClient";

export function useLockDateQuery(entityId?: number | null) {
    return useQuery({
        queryKey: getLockQueryKey(entityId),
        queryFn: () => getLock(entityId),
        refetchOnMount: false,
        enabled: entityId != null,
    });
}

export function useLockDateState(entityId?: number | null) {
    const query = useLockDateQuery(entityId);
    const lockDate = useMemo(() => getLockDate(query.data), [query.data]);
    const isResolved = entityId == null || query.isSuccess;
    return { lockDate, isResolved, isError: query.isError };
}

export function useLockDate(entityId?: number | null) {
    return useLockDateState(entityId).lockDate;
}

export function useLockListState(entityIds: number[]) {
    const query = useQuery({
        queryKey: getLocksQueryKey(entityIds),
        queryFn: () => getLocks(entityIds),
        refetchOnMount: false,
    });

    const isResolved = entityIds.length === 0 || query.isSuccess;
    return { locks: query.data ?? [], isResolved };
}

export function useLockList(entityIds: number[]): Lock[] {
    return useLockListState(entityIds).locks;
}
